import { Injectable, inject } from '@angular/core';
import { UserModel } from '@core/store/user/user.model';
import { UserState, UserStore } from '@core/store/user/user.store';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs/internal/Observable';
import { share } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserQuery extends Query<UserState> {
  protected store: UserStore;

  getUser$: Observable<UserModel> = this.select(userStore => userStore.user);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const store = inject(UserStore);

    super(store);
  
    this.store = store;
  }
}
